<template>
  <img class="app-logo" :src="logoSrc" alt="EFSTA logo" />
  <theme-button />
  <language-switch />
  <div class="app-container">
    <div class="control-container">
      <div class="file-container">
        <FileControl />
      </div>
      <div class="summary-container">
        <SummaryControl />
      </div>
    </div>
    <div class="result-container">
      <ResultView />
    </div>
  </div>
  <div v-if="dataStore.isModalVisible" class="modal-overlay">
    <div class="modal-box">
      <p class="modal-title">{{ dataStore.modalTitle }}</p>
      <p class="modal-body">{{ dataStore.modalBody }}</p>
      <div class="modal-buttons">
        <button v-if="dataStore.hasCancelButton" class="cancel-btn" @click="dataStore.closeModal">CANCEL</button>
        <button class="continue-btn" @click="confirmModal">RESET</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useDataStore } from '@/stores/dataStore.js'
import FileControl from '@/components/FileControl.vue'
import SummaryControl from '@/components/SummaryControl.vue'
import ResultView from '@/components/ResultView.vue'
import ThemeButton from './components/ThemeButton.vue'
import LanguageSwitch from './components/LanguageSwitch.vue'
import logoEfstaBlue from '@/assets/logo_efsta_blue.svg'
import logoEfstaWhite from '@/assets/logo_efsta_white.svg'

const dataStore = useDataStore()
const currentTheme = ref('light-theme')

const syncTheme = () => {
  currentTheme.value = document.documentElement.className || localStorage.getItem('user-theme') || 'light-theme'
}

const logoSrc = computed(() => (
  currentTheme.value === 'light-theme' ? logoEfstaBlue : logoEfstaWhite
))

onMounted(() => {
  syncTheme()
  window.addEventListener('theme-changed', syncTheme)
})

onBeforeUnmount(() => {
  window.removeEventListener('theme-changed', syncTheme)
})

const confirmModal = () => {
  dataStore.reloadPage()
  dataStore.closeModal()
}
</script>


<style>
* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  background: var(--background-color-primary);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary-color);
  height: 100%;
  width: 100%;
  padding: 50px;
}

.app-logo {
  position: fixed;
  top: 0.7rem;
  left: 0.7rem;
  z-index: 800;
  width: 100px;
  height: auto;
}

.app-container {
  display: flex;
  justify-content: center;
  gap: 30px;
  height: 100%;
}

.result-container {
  overflow: hidden;
  flex: 0 1 100%;
  border-radius: 10px;
  min-height: 783px;
}

.control-container {
  flex: 0 1 30%;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

/* .file-container {
  min-height: 415px;
} */

.control-container .file-container {
  flex: 1 1 100%;
  overflow-y: auto;
  /* max-height: 600px; */
  border-radius: 10px;
  min-height: 400px;
}

.control-container .summary-container {
  flex: 0 0 auto;
}

@media (max-width: 1200px) {
  #app {
    height: auto;
    padding: 20px;
  }

  .file-container {
    max-height: 700px;
    overflow-y: auto;
  }

  .app-container {
    flex-direction: column;
    justify-content: start;
  }

  .result-container {
    flex: 0 1 auto;
    width: 100%;
  }

  .control-container {
    flex: 0 1 auto;
    width: 100%;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background-color: var(--box-background-color);
  border-radius: 8px;
  padding: 25px;
  width: 600px;
  min-height: 200px;
  position: relative;
  flex-direction: column;
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-title {
  font-weight: bold;
  font-size: 20px;
  margin: 0;
  color: var(--text-primary-color);
}

.modal-body {
  color: var(--text-primary-color);
}

.modal-buttons {
  position: absolute;
  bottom: 25px;
  right: 25px;
  display: flex;
  gap: 20px;
  justify-content: flex-end;
}

.cancel-btn {
  background-color: var(--cancel-button-background-color);
  font-weight: bold;
  color: var(--cancel-button-text-color);
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.continue-btn {
  background-color: var(--continue-button-background-color);
  font-weight: bold;
  border: none;
  color: var(--continue-button-text-color);
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}
</style>
